module.exports = __webpack_public_path__ + "img/jy-dages.1b25be46.jpg";